import { useSelector } from 'hooks';

export const useWorkout = () => {
    const { workout, isLoading, blocks, playlist, workoutExercises, plan, name } = useSelector(
        (state) => state.workouts
    );

    return {
        workout,
        isLoading,
        blocks,
        playlist,
        plan,
        workoutExercises,
        name,
    };
};
